<template>
  <main id="page_sub">
    <section id="page_contents" class="tcenter">
      <h5><p><img src="../../assets/images/img_finish.png" alt=""/></p>
        <p>로그인 설정이 완료되었습니다!</p></h5>
      <span>환영합니다! 로그인 하시면 경영지원플랫폼의 다양한 서비스를 이용하실 수 있습니다. </span>
      <!--- 버튼영역 버튼 켄도 사용 --->
      <div class="btn_area mt20">
        <button id="primaryTextButton" class="k-primary k-button" data-role="button" role="button" aria-disabled="false"
                tabindex="0" @click="goMainPage">메인으로 이동
        </button>
      </div>
      <!--- //버튼영역 --->
    </section>
  </main>
</template>
<script>
  export default {
    name: "LoginSettingComplete",
    methods: {
      goMainPage: function () {

        this.$router.push({name: 'Main'})

      }
    }
  }
</script>
